/* eslint-disable react/button-has-type */
/* eslint-disable import/no-named-as-default */
import React from 'react';
import MakeRequisition from './MakeRequisition';
import ManagersRequisition from '../managers/ManagersRequisition';
import ApprovedRequisition from './ApprovedRequisition';
import { useRequisition } from '../../../../../hooks/shared/requisition/useRequisition';
import { RequisitionProvider } from '../../../../../context/shared/requisitions/RequsitionContext';
import ExecutivesRequistion from '../executives/v2/ExecutivesRequistion';
import EmployeesRequisitions from '../employees/EmployeesRequisitions';
import { OPERATIONS, TECHNICAL_SUPPORT } from '../../../../../utils/departments/helpers';
import FilterByCountry from './filters/manager/FilterByCountry';
import ManagerRequisition from './ManagerRequisition';
import FieldSupportFilters from './filters/manager/FieldSupportFilters';
import { NOC } from '../../../../../utils/config';
import NocFilters from './filters/manager/NocFilters';
import { useDepartments } from '../../../../../hooks/shared/departments/useDepartments';
import ExecutivesRequsitions from '../../../departments/accounts/requsitions/executives/ExecutivesRequsitions';
import { useRequsitions } from '../../../../../hooks/accounts/useRequisitions';

const Requisitions = () => {
  const {
    isFetching: fetching,
    requistions,
    getAccountsRequsitionByStatus,
    approving,
    showModal,
    onClickShowModal,
    setCheckAllRequisition,
    setCheckOneOfAllRequisition,
  } = useRequsitions();
  const userCountry = sessionStorage.getItem('country');
  const {
    managerRequisitions,
    totalPages,
    isFetching,
    onChangeRequisition,
    requisition,
    onFileChange,
    file,
    employeesPages,
    handlePageClick,
    handlePageClicks,
    setManagerApproval,
    makeRequisition,
    isLoading,
    executiveRequisitions,
    percentage,
    giveManagerApproval,
    giveManagerDisApproval,
    onChangeApproveOrDisapprove,
    status,
    isApprovingOrDisapproving,
    giveExecutiveApproval,
    giveExecutiveDisApproval,
    employeesRequisitions,
    // disapproveRequisition,
    onChangeDisapprove,
    disapprove,
    onChangeApprove,
    approve,
    department,
    onChange,
    getFieldSupportRequisition,
    account,
    onChangeAccountStatus,
    getRequisitionByAccountStatus,
    filterRequisitionByCountry,
    filterExecutiveRequisitionByCountry,
    getManagersRaisedRequisition,
    getRequsitionsByDepartment,
    getManagerApprovedRequsitionsByDepartment,
    getManagersRequisition,
  } = useRequisition();
  const { departments } = useDepartments();
  const [page] = React.useState(1);
  const searchState = {
    reqstatus: '',
    country: (userCountry === 'CIV' && 'cv') || (userCountry === 'GH' && 'gh') || (userCountry === 'NG' && 'ng'),
    category: '',
    reqdepartment: '',
  };
  const [search, setSearch] = React.useState(searchState);
  const { reqstatus, country, reqdepartment, category } = search;
  const handlePage = (data) => {
    const selectedPage = data.selected + 1;
    getAccountsRequsitionByStatus(search, selectedPage);
  };
  const onInputChange = (e) => {
    const { name, value } = e.target;
    setSearch({
      ...search,
      [name]: value,
    });
  };
  const submit = () => {
    return reqdepartment.length > 0 && reqstatus.length > 0 && country.length > 0 && category.length > 0;
  };
  const handleSubmit = (search, page) => {
    if (reqdepartment === 'all') {
      const data = {
        status: reqstatus,
        country,
        category,
      };
      getAccountsRequsitionByStatus(data, page);
    } else {
      const data = {
        status: reqstatus,
        country,
        category,
        department_id: reqdepartment,
      };
      getAccountsRequsitionByStatus(data, page);
    }
  };
  const checkRole = () => {
    if (Number(`${sessionStorage.getItem('roleId')}`) > 2) {
      return (
        <RequisitionProvider
          value={{
            managerRequisitions,
            totalPages,
            handlePageClick,
            isFetching,
            onChangeApproveOrDisapprove,
            status,
            isApprovingOrDisapproving,
            giveManagerApproval,
            giveManagerDisApproval,
            makeRequisition,
            isLoading,
            onChangeRequisition,
            requisition,
            onFileChange,
            file,
            percentage,
            // disapproveRequisition,
            onChangeDisapprove,
            disapprove,
            onChangeApprove,
            approve,
            department,
            onChange,
            getFieldSupportRequisition,
            account,
            onChangeAccountStatus,
            getRequisitionByAccountStatus,
            filterRequisitionByCountry,
            getManagersRaisedRequisition,
            getRequsitionsByDepartment,
            getManagerApprovedRequsitionsByDepartment,
            setManagerApproval,
          }}
        >
          <div className="row">
            {sessionStorage.getItem('officialEmail') === 'ikenna.uche@tizeti.com' ||
            sessionStorage.getItem('officialEmail') === 'moyosore.james@tizeti.com' ? (
              <>
                {sessionStorage.getItem('departmentId') === `${OPERATIONS}` && <FieldSupportFilters />}
                {sessionStorage.getItem('departmentId') === `${NOC}` && <NocFilters />}
              </>
            ) : // <div className="col-lg-12 col-md-9 col-sm-12 mt-3 mb-3 d-flex px-10">
            //   <div className="fliter copy-font d-flex mr-auto">
            //     <small className="mt-2">Filter By:</small>
            //     <span>
            //       <select className="form-control" name="reqdepartment" onChange={onInputChange}>
            //         <option>Select By Departments</option>
            //         {departments.map((dept) => {
            //           return (
            //             <option value={dept.id} key={dept.id}>
            //               {dept.name}
            //             </option>
            //           );
            //         })}
            //         <option value="all">All Departments</option>
            //       </select>
            //     </span>

            //     <small className="mt-2">Filter By:</small>
            //     <span>
            //       <select className="form-control" name="reqstatus" onChange={onInputChange}>
            //         <option>Select By Status</option>
            //         <option value="rejected">Rejected</option>
            //         <option value="approved">Approved</option>
            //         <option value="queued">Queued</option>
            //       </select>
            //     </span>
            //     {/* fillter by category */}
            //     <small className="mt-2">Filter By:</small>
            //     <span>
            //       <select className="form-control" name="category" onChange={onInputChange}>
            //         <option>Select By Category</option>
            //         <option value="petty-cash">Petty Cash</option>
            //         <option value="requisition">Requisition</option>
            //       </select>
            //     </span>
            //     <small className="mt-2">Filter By Country:</small>
            //     <span>
            //       <select className="form-control" name="country" onChange={onInputChange}>
            //         <option>Select Country</option>
            //         <option value="ng">Nigeria</option>
            //         <option value="gh">Ghana</option>
            //         <option value="cv">Cote d'Ivoire</option>
            //       </select>
            //     </span>
            //     <div className="mt-1 mb-3">
            //       <button
            //         onClick={() => handleSubmit(search, page)}
            //         className="btn btn-green copy-font"
            //         disabled={!submit()}
            //       >
            //         Search
            //       </button>
            //     </div>
            //   </div>
            // </div>

            null}
            <span className="col-12 d-flex justify-content-between">
              <div className="my-3 col-6">
                <FilterByCountry />
                <button
                  className="btn btn-info mt-1 copy-font ml-3"
                  type="submit"
                  onClick={async () => {
                    setManagerApproval(false);
                    await getManagersRequisition(1);
                  }}
                >
                  Default
                </button>
              </div>
              <div className="d-flex">
                <ApprovedRequisition />
                <ManagerRequisition />
                <MakeRequisition />
              </div>
            </span>
            <ManagersRequisition />
          </div>
        </RequisitionProvider>
      );
    }
    if (Number(`${sessionStorage.getItem('roleId')}`) > 3 && Number(`${sessionStorage.getItem('roleId')}`) !== 6) {
      return (
        <RequisitionProvider
          value={{
            isFetching,
            isApprovingOrDisapproving,
            makeRequisition,
            isLoading,
            onChangeRequisition,
            requisition,
            onFileChange,
            file,
            percentage,
            executiveRequisitions,
            giveExecutiveApproval,
            giveExecutiveDisApproval,
            // disapproveRequisition,
            onChangeDisapprove,
            disapprove,
            filterExecutiveRequisitionByCountry,
          }}
        >
          <div className="row">
            <MakeRequisition />
            {/* <ExecutiveFilterByCountry /> */}
            {/* <ExecutivesRequsitions
            load={fetching}
            handlePageClick={handlePage}
            totalPages={totalPages}
            approving={approving}
            requistions={requistions}
            giveExecutiveApproval={giveExecutiveApproval}
            giveExecutiveDisApproval={giveExecutiveDisApproval}
            showModal={showModal}
            onClickShowModal={onClickShowModal}
            setCheckAllRequisition={setCheckAllRequisition}
            setCheckOneOfAllRequisition={setCheckOneOfAllRequisition}
          /> */}
            <ExecutivesRequistion />
          </div>
        </RequisitionProvider>
      );
    }
    return (
      <RequisitionProvider
        value={{
          isFetching,
          makeRequisition,
          isLoading,
          onChangeRequisition,
          requisition,
          onFileChange,
          file,
          percentage,
          employeesRequisitions,
        }}
      >
        <div className="row">
          <MakeRequisition />
          <EmployeesRequisitions totalPages={employeesPages} handlePageClick={handlePageClicks} />
        </div>
      </RequisitionProvider>
    );
  };

  return (
    <div className="container-fluid">
      <div className="row mt-3">
        <div className="col-lg-12 col-md-12 col-sm-12 mt-5">{checkRole()}</div>
      </div>
    </div>
  );
};

export default Requisitions;
